const API_URL = process.env.REACT_APP_BACKEND_URL;
const VID_KEY = 'sg_vid';
const ATTR_KEY = 'sg_attr';

const store = {
  get: (k) => { try { return localStorage.getItem(k); } catch { return null; } },
  set: (k, v) => { try { localStorage.setItem(k, v); } catch { /* private mode */ } },
};

export const getVisitorId = () => {
  let id = store.get(VID_KEY);
  if (!id) {
    id = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
    store.set(VID_KEY, id);
  }
  return id;
};

const currentTouch = () => {
  const p = new URLSearchParams(window.location.search);
  const ref = document.referrer && !document.referrer.startsWith(window.location.origin) ? document.referrer : '';
  return {
    utm_source: (p.get('utm_source') || '').slice(0, 120),
    utm_medium: (p.get('utm_medium') || '').slice(0, 120),
    utm_campaign: (p.get('utm_campaign') || '').slice(0, 120),
    utm_content: (p.get('utm_content') || '').slice(0, 120),
    referrer: ref.slice(0, 300),
    landing_path: window.location.pathname.slice(0, 200),
    fbclid: p.has('fbclid'),
    gclid: p.has('gclid'),
  };
};

// First touch, except a later ad/campaign click replaces it so signups credit the ad.
export const captureAttribution = () => {
  const touch = currentTouch();
  const isCampaign = touch.utm_source || touch.fbclid || touch.gclid;
  if (store.get(ATTR_KEY) && !isCampaign) return;
  store.set(ATTR_KEY, JSON.stringify(touch));
};

const TRACKED = /^\/(pricing|blog(\/[^/]+)?|bracket-library|terms|privacy|(basketball|soccer|volleyball|softball|flag-football)-league-software|share\/.+|stats\/leaderboard\/.+)?\/?$/;
let lastView = { path: '', at: 0 };

export const trackPageView = (pathname) => {
  if (!TRACKED.test(pathname) || store.get('session_token')) return;
  const now = Date.now();
  if (lastView.path === pathname && now - lastView.at < 1500) return;
  lastView = { path: pathname, at: now };
  const touch = currentTouch();
  let entry = !!(touch.utm_source || touch.fbclid || touch.gclid);
  try { entry = entry || !sessionStorage.getItem('sg_entry'); sessionStorage.setItem('sg_entry', '1'); } catch { /* ignore */ }
  trackGrowth('page_view', { path: pathname, entry, ...(entry ? { attr: touch } : {}) });
};

export const trackGrowth = (type, extra = {}) => {
  fetch(`${API_URL}/api/growth/events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ visitor_id: getVisitorId(), type, ...extra }),
    keepalive: true,
  }).catch(() => {});
};

// Called once right after a brand-new account is created.
export const linkSignup = (token) => {
  let attribution = null;
  try { attribution = JSON.parse(store.get(ATTR_KEY) || 'null'); } catch { /* ignore */ }
  fetch(`${API_URL}/api/growth/link`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ visitor_id: store.get(VID_KEY), attribution }),
  }).catch(() => {});
};
